export default __webpack_public_path__ + "static/media/VIBE-Logo-New.cdb041d7.png";